import { Component, OnInit, NgZone } from '@angular/core';
import { TitleService } from '@app/shared/services/title.service';
import { MenuService } from '@app/shared/services/menu.service';
import * as moment from 'moment/moment';
import { ReservationsService } from '@app/shared/services/reservations.service';
import { FacturationService } from '@app/shared/services/facturation.service';
import { ExcelService } from '@app/shared/services/excel.service';
import { SessionService } from '@app/shared/services/session.service';
import { UsersService } from '@app/shared/services/users.service';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from '@app/shared/services/alert.service';

import { Router } from '@angular/router';

import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from "rxjs/internal/operators";

@Component({
    selector: 'app-virements-list',
    templateUrl: './virements-list.component.html',
    styleUrls: ['./virements-list.component.scss']
})
export class VirementsListComponent implements OnInit {
    public month: string = "0";


    public virements: Array<any> = [];

    public virementsSave: Array<any> = [
        {
            courses: [
                {
                    "prix": 63,
                    "kilometre": 100,
                    "Code": "R140021",
                    "ISODateEnd": "2022-03-30T19:00:00.0000000Z",
                    "ISODateStart": "2022-03-30T17:00:00.0000000Z",
                    "ISORealDateEnd": "",
                    "ISORealDateStart": "",
                    "Id": 105833,
                    "User": "TLastName TFistName",
                    "Vehicle": "VEHICLE 121"
                },
                {
                    "prix": 63,
                    "kilometre": 100,
                    "Code": "R140022",
                    "ISODateEnd": "2022-03-30T19:00:00.0000000Z",
                    "ISODateStart": "2022-03-30T12:00:00.0000000Z",
                    "ISORealDateEnd": "",
                    "ISORealDateStart": "",
                    "Id": 105834,
                    "User": "TLastName TFistName",
                    "Vehicle": "VEHICLE 121"
                },
                {
                    "prix": 63,
                    "kilometre": 100,
                    "Code": "R010010",
                    "ISODateEnd": "2022-03-30T00:00:00.0000000Z",
                    "ISODateStart": "2022-03-29T22:00:00.0000000Z",
                    "ISORealDateEnd": "",
                    "ISORealDateStart": "",
                    "Id": 105828,
                    "User": "TLastName TFistName",
                    "Vehicle": "FG-509-NH"
                },
                {
                    "prix": 63,
                    "kilometre": 100,
                    "Code": "R010011",
                    "ISODateEnd": "2022-03-30T00:00:00.0000000Z",
                    "ISODateStart": "2022-03-29T22:00:00.0000000Z",
                    "ISORealDateEnd": "",
                    "ISORealDateStart": "",
                    "Id": 105829,
                    "User": "TLastName TFistName",
                    "Vehicle": "EN-403-KM"
                },
                {
                    "prix": 63,
                    "kilometre": 100,
                    "Code": "R011342",
                    "ISODateEnd": "2022-03-29T20:00:00.0000000Z",
                    "ISODateStart": "2022-03-29T18:00:00.0000000Z",
                    "ISORealDateEnd": "",
                    "ISORealDateStart": "",
                    "Id": 105830,
                    "User": "Fabien Bouns",
                    "Vehicle": "EH-702-JG"
                },
                {
                    "prix": 63,
                    "kilometre": 100,
                    "Code": "R146319",
                    "ISODateEnd": "2022-03-21T21:51:00.0000000Z",
                    "ISODateStart": "2022-03-21T18:51:00.0000000Z",
                    "ISORealDateEnd": "2022-03-21T21:45:54.0000000Z",
                    "ISORealDateStart": "2022-03-21T18:52:12.0000000Z",
                    "Id": 105817,
                    "User": "Manon boulestin",
                    "Vehicle": "FG-509-NH"
                }
            ],
            adherent: "MODULAUTO",
            adherentId: 20,
            versee: 312,
            dateDebut: "2022-03-00T21:51:00.0000000Z",
            dateFin: "2022-03-30T21:51:00.0000000Z",
            virementDate: "2022-04-01T21:51:00.0000000Z"
        },
        {
            courses: [
                {
                    "prix": 63,
                    "kilometre": 100,
                    "Code": "R140021",
                    "ISODateEnd": "2022-03-30T19:00:00.0000000Z",
                    "ISODateStart": "2022-03-30T17:00:00.0000000Z",
                    "ISORealDateEnd": "",
                    "ISORealDateStart": "",
                    "Id": 105833,
                    "User": "Maxime Di Nsatal",
                    "Vehicle": "VEHICLE 121"
                },
            ],
            adherent: "MOD-PIC",
            adherentId: 20,
            versee: 312,
            dateDebut: "2021-01-00T21:51:00.0000000Z",
            dateFin: "2021-01-30T21:51:00.0000000Z",
            virementDate: "2021-02-01T21:51:00.0000000Z"
        },
        {
            courses: [],
            adherent: "MOD-EDEN",
            adherentId: 20,
            versee: 312,
            dateDebut: "2022-02-00T21:51:00.0000000Z",
            dateFin: "2022-02-30T21:51:00.0000000Z",
            virementDate: "2022-03-02T21:51:00.0000000Z"
        },
        {
            courses: [],
            adherent: "MOD-EDEN",
            adherentId: 20,
            versee: 312,
            dateDebut: "2022-02-00T21:51:00.0000000Z",
            dateFin: "2022-02-30T21:51:00.0000000Z",
            virementDate: "2022-03-02T21:51:00.0000000Z"
        }, {
            courses: [],
            adherent: "MOD-EDEN",
            adherentId: 20,
            versee: 312,
            dateDebut: "2022-02-00T21:51:00.0000000Z",
            dateFin: "2022-02-30T21:51:00.0000000Z",
            virementDate: "2022-03-02T21:51:00.0000000Z"
        }, {
            courses: [],
            adherent: "MOD-EDEN",
            adherentId: 20,
            versee: 312,
            dateDebut: "2022-02-00T21:51:00.0000000Z",
            dateFin: "2022-02-30T21:51:00.0000000Z",
            virementDate: "2022-03-02T21:51:00.0000000Z"
        }, {
            courses: [],
            adherent: "MOD-EDEN",
            adherentId: 20,
            versee: 312,
            dateDebut: "2022-02-00T21:51:00.0000000Z",
            dateFin: "2022-02-30T21:51:00.0000000Z",
            virementDate: "2022-03-02T21:51:00.0000000Z"
        }, {
            courses: [],
            adherent: "MOD-EDEN",
            adherentId: 20,
            versee: 312,
            dateDebut: "2022-02-00T21:51:00.0000000Z",
            dateFin: "2022-02-30T21:51:00.0000000Z",
            virementDate: "2022-03-02T21:51:00.0000000Z"
        }, {
            courses: [],
            adherent: "MOD-EDEN",
            adherentId: 20,
            versee: 312,
            dateDebut: "2022-02-00T21:51:00.0000000Z",
            dateFin: "2022-02-30T21:51:00.0000000Z",
            virementDate: "2022-03-02T21:51:00.0000000Z"
        }, {
            courses: [],
            adherent: "MOD-EDEN",
            adherentId: 20,
            versee: 312,
            dateDebut: "2022-02-00T21:51:00.0000000Z",
            dateFin: "2022-02-30T21:51:00.0000000Z",
            virementDate: "2022-03-02T21:51:00.0000000Z"
        },
    ];

    /* Filters */

    public pickerReservation: any;
    public status: number = 0;
    public search: string = '';
    public searchChanged: Subject<string> = new Subject<string>();
    public societySearch: string = '';

    /* List */

    public reservations: Array<any> = [];
    public comeUp: Array<any> = [];
    public inProgress: Array<any> = [];
    public finished: Array<any> = [];
    public canceled: Array<any> = [];
    public maxPages: number = 1;
    public currentPage: number = 1;
    public loadingStatus: boolean = false;
    public noResult: boolean = false;
    public excelLoading: boolean = false;

    public years: Array<any> = [];
    public selectYear: number = 0;

    constructor(
        private titleService: TitleService,
        private menu: MenuService,
        private reservationService: ReservationsService,
        private excelService: ExcelService,
        private route: ActivatedRoute,
        public session: SessionService,
        private userService: UsersService,
        private alertService: AlertService,
        private facturationService: FacturationService,

        private router: Router,
    ) {
        this.searchChanged
            .pipe(debounceTime(1000), distinctUntilChanged())
            .subscribe(model => {
                this.search = model;
                this.currentPage = 1;
                sessionStorage.setItem('GainFilterSearch', this.search);
                this.updateVirement();
            });
    }

    retrieveFilters() {
        this.month = "0";
        this.selectYear = moment().year();
    }

    ngOnInit() {
        this.menu.setMenuState('facturation', 'facturation', 'versement');
        this.getEncaissement()
        this.initYearFilter();
        this.route.queryParams
            .subscribe(params => {
                if (params.vehicule) {
                    this.search = params.vehicule;
                    sessionStorage.setItem('ReservationFilterSearch', params.vehicule);
                    this.updateReservations();
                }
            });

        this.titleService.setTitle(`Versement / VOP`);
        // this.menu.setMenuState('reservation', 'reservation', '');
        this.retrieveFilters();
        if ('ReservationList' in sessionStorage
            && moment(sessionStorage.getItem('ReservationListTimeout')).isBetween(moment().subtract(2, 'minute'), moment())) {
            this.reservations = JSON.parse(sessionStorage.getItem('ReservationList'));
            this.maxPages = parseInt(sessionStorage.getItem('ReservationListMaxPages'), 10);
            this.currentPage = parseInt(sessionStorage.getItem('ReservationListCurrentPage'), 10);

            if (this.status !== 0) {
                this.sortReservationsByStatus();
            }

            this.sortReservationsByDate();
            this.getStaffStatus();
            this.getFinishedInvoiceFields();
            this.loadingStatus = false;
        } else {
            // this.initReservations(0);
        }
    }

    async getEncaissement() {
        this.loadingStatus = true;
        try {
            this.virements = await this.facturationService.getEncaissement();
        } catch (error) {
            this.virements = []
        }


        console.log(this.virements);
        this.calculePrix()
        this.loadingStatus = false;
    }

    async updateVirement() {
        console.log(this.search)

        this.virements = await this.facturationService.getEncaissement();

        if (this.search.length > 0) {
            this.virements = this.virements.filter(virement => virement.adherent.toLowerCase().includes(this.search.toLowerCase()));
        }

        //month and year filter
        if (this.month !== "0") {
            this.virements = this.virements.filter(virement => moment(virement.virementDate).month().toString() == this.month);
        }

        if (this.selectYear !== 0) {
            this.virements = this.virements.filter(virement => moment(virement.virementDate).year() == this.selectYear);
        }
    }

    async calculePrix() {
        for (let virement of this.virements) {
            let prixCourse = 0;

            if (virement.courses && virement.courses.length > 0) {
                for (let i = 0; i < virement.courses.length; i++) {
                    prixCourse += virement.courses[i].prix
                }
            }

            virement.versee = prixCourse;
        }

        console.log(this.virements)
    }

    onMonthChange(monthId): void {
        console.log(monthId, "refr");
        this.month = monthId
        this.updateVirement()
    }

    onYearChange(year): void {
        console.log(year, "refr");
        this.selectYear = year;
        this.updateVirement()
    }

    initYearFilter() {
        this.years = [];
        for (let i = moment().year(); i >= 2015; i--) {
            this.years.push(i.toString());
        }
    }

    changeStatus(status): void {
        this.status = status;
        sessionStorage.setItem('ReservationFilterStatus', this.status.toString());
        this.updateReservations();
    }

    onSearchChange(search): void {
        this.searchChanged.next(search);
    }


    setReservations(res): void {
        this.reservations = res;
        console.log("session: ", this.session)
        sessionStorage.setItem('ReservationList', JSON.stringify(this.reservations));
        sessionStorage.setItem('ReservationListMaxPages', this.maxPages.toString());
        sessionStorage.setItem('ReservationListCurrentPage', this.currentPage.toString());
        sessionStorage.setItem('ReservationListTimeout', moment().format());

        //test reservation global
        if (this.status !== 0) {
            this.sortReservationsByStatus();
            this.sortReservationsByDate();
        }
        else {
            console.log("reservation:", this.reservations)
            this.comeUp = [];
            this.inProgress = [];
            this.finished = [];
            this.canceled = [];
            this.sortReservationsByDateGlobal();
        }

        this.getStaffStatus();
        this.getFinishedInvoiceFields();
    }

    sortReservationsByStatus(): void {
        this.comeUp = [];
        this.inProgress = [];
        this.finished = [];
        this.canceled = [];
        this.reservations.forEach((reservation) => {
            if (reservation.Status === -1) {
                this.canceled.push(reservation);
            }
            if (reservation.Status >= 0 && reservation.Status <= 2) {
                this.comeUp.push(reservation);
            }
            if (reservation.Status >= 3 && reservation.Status <= 10) {
                this.inProgress.push(reservation);
            }
            if (reservation.Status >= 11 && reservation.Status <= 14) {
                this.finished.push(reservation);
            }
        });
    }

    sortReservationsByDate(): void {
        [this.finished, this.comeUp, this.inProgress, this.canceled].forEach((reservationList) => {
            console.log("reservationList: ", reservationList)
            reservationList.sort((a, b) => {
                if (a.ISODateStart > b.ISODateStart)
                    return -1;
                if (a.ISODateStart < b.ISODateStart)
                    return 1;
                return 0;
            });
        });
    }

    sortReservationsByDateGlobal(): void {
        this.reservations.sort((a, b) => {
            if (a.ISODateStart > b.ISODateStart)
                return -1;
            if (a.ISODateStart < b.ISODateStart)
                return 1;
            return 0;
        });
    }

    getFinishedInvoiceFields(): void {
        this.finished.forEach((reservation, index) => {
            this.reservationService.getReservationInvoiceFields(reservation.Id).then((res) => {
                reservation.totalAmount = 0;
                if (res && res.length > 0) {
                    res.forEach((line) => {
                        reservation.totalAmount += line.IncludingTaxes * line.Quantity;
                    });
                }
            });
        });
    }

    getStaffStatus(): void {
        [this.finished, this.comeUp, this.inProgress, this.canceled].forEach((reservationList) => {
            reservationList.forEach((reservation) => {
                reservation.loading = true;
                this.userService.getUser(reservation.IdAccount).then((user) => {
                    reservation.CodeSociety = user.CodeSociety;
                    if (user.IdAccountDemo > 0) {
                        reservation.demo = true;
                    } else {
                        reservation.demo = false;
                    }
                    reservation.loading = false;
                });
            });
        });
    }

    initVirement(next) {

    }

    updateReservations() {
        this.loadingStatus = true;
    }

    nextPage() {
        if (this.currentPage < this.reservationService.maxPages) {
            this.loadingStatus = true;
            this.currentPage += 1;
        }
    }

    goPage(page): any {
        this.loadingStatus = true;
        this.currentPage = page;
    }

    prevPage() {
        if (this.currentPage > 1) {
            this.loadingStatus = true;
            this.currentPage -= 1;
        }
    }

    goToControl(): void {
        this.router.navigate(['facturation/controle']);
    }

    goToGain(): void {
        this.router.navigate(['facturation/gain']);
    }
}